import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { FileText } from 'lucide-react';
import { ReportSetup } from '../types';

interface ReportSetupFormProps {
  reportSetup: ReportSetup;
  onReportSetupChange: (setup: ReportSetup) => void;
}

const ReportSetupForm: React.FC<ReportSetupFormProps> = ({
  reportSetup,
  onReportSetupChange
}) => {
  const handleInputChange = (field: keyof ReportSetup, value: string) => {
    onReportSetupChange({
      ...reportSetup,
      [field]: value
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Report Setup
        </CardTitle>
        <CardDescription>
          Configure client and company information for the report
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="clientName">Client Name</Label>
            <Input
              id="clientName"
              placeholder="Enter client name"
              value={reportSetup.clientName}
              onChange={(e) => handleInputChange('clientName', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="clientWebsite">Client Website</Label>
            <Input
              id="clientWebsite"
              placeholder="https://example.com"
              value={reportSetup.clientWebsite}
              onChange={(e) => handleInputChange('clientWebsite', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="companyName">Your Company Name</Label>
            <Input
              id="companyName"
              placeholder="Enter your company name"
              value={reportSetup.companyName}
              onChange={(e) => handleInputChange('companyName', e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="companyAddress">Company Address</Label>
            <Input
              id="companyAddress"
              placeholder="Enter company address"
              value={reportSetup.companyAddress}
              onChange={(e) => handleInputChange('companyAddress', e.target.value)}
            />
          </div>
          <div className="md:col-span-2 space-y-2">
            <Label htmlFor="companySubtext">Company Subtext / Tagline</Label>
            <Textarea
              id="companySubtext"
              placeholder="Enter company tagline or additional information"
              value={reportSetup.companySubtext}
              onChange={(e) => handleInputChange('companySubtext', e.target.value)}
              rows={2}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReportSetupForm;
